import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Menu from "../Menu";
import useApiUrls from "../../useApiUrls";
import SuccessMessage from "../../components/successMessage";
import FailedMessage from "../../components/FailedMessage";

const UpdateFirmware = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { getUrlByOperation } = useApiUrls();

  // State to hold form data
  const [formData, setFormData] = useState({
    id: id || 0,
    firmwarename: "",
    firmwareversion: "",
    remark: "",
    active: true,
    filename: ""
  });

  const [message, setMessage] = useState("");

  // Fetch the existing data for the firmware
  useEffect(() => {
    if (id) {
      const fetchFirmwareData = async () => {
        const token = getCookie("token");
        const userid = getCookie("userid");

        if (!token || !userid) {
          console.error("Missing token or userId");
          return;
        }

        try {
          const response = await axios.post(
            'https://api.dqr-display-tms.eventum.co.in/api/FirmwareOperation/Search',
            {
              id: parseInt(id),
              ispageload: true,
              withoutpagination: true
            },
            {
              headers: {
                "accept": "text/plain",
                "X-Authorization": token,
                "UserId": userid,
                "Content-Type": "application/json-patch+json",
              },
            }
          );

          if (response.data && response.data.data && response.data.data.length > 0) {
            const firmwareData = response.data.data[0];
            setFormData({
              id: firmwareData.id,
              firmwarename: firmwareData.firmwarename || "",
              firmwareversion: firmwareData.firmwareversion || "",
              remark: firmwareData.remark || "",
              active: firmwareData.active === "Active" || firmwareData.active === true,
              filename: firmwareData.filename || ""
            });
          }
        } catch (error) {
          console.error("Error fetching firmware data:", error);
          setMessage("Failed to fetch firmware data.");
        }
      };

      fetchFirmwareData();
    }
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: name === "active" ? value === "true" : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      console.error("Missing token or userId");
      return;
    }

    const updateData = {
      id: parseInt(formData.id),
      active: formData.active,
      remark: formData.remark,
      firmwarename: formData.firmwarename,
      firmwareversion: formData.firmwareversion
    };

    try {
      await axios.post(
        'https://api.dqr-display-tms.eventum.co.in/api/FirmwareOperation/Update',
        updateData,
        {
          headers: {
            "accept": "text/plain",
            "X-Authorization": token,
            "UserId": userid,
            "Content-Type": "application/json-patch+json",
          },
        }
      );
      setMessage("Firmware updated successfully!");
      setTimeout(() => navigate("/Firmware"), 3000);
    } catch (error) {
      console.error("Error updating firmware:", error);
      setMessage("Failed to update firmware.");
    }
  };

  return (
    <>
      <Menu />
      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6"></div>
              </div>
            </div>
          </section>

          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="card card-info">
                    <div className="card-header">
                      <h3 className="card-title">
                        {id ? "Update" : "Add"} Firmware
                      </h3>
                    </div>
                    <div className="card-body">
                      <form id="add-items" onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Firmware Name</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.firmwarename}
                                onChange={handleChange}
                                placeholder="Enter firmware name"
                                name="firmwarename"
                                required
                              />
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Firmware Version</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.firmwareversion}
                                onChange={handleChange}
                                placeholder="Enter version"
                                name="firmwareversion"
                                required
                              />
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Remark</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.remark}
                                onChange={handleChange}
                                placeholder="Enter remark"
                                name="remark"
                              />
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>File Name</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.filename}
                                onChange={handleChange}
                                placeholder="File name"
                                name="filename"
                                disabled
                               
                              />
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Status</label>
                              <select
                                className="form-control"
                                name="active"
                                value={formData.active}
                                onChange={handleChange}
                              >
                                <option value={true}>Active</option>
                                <option value={false}>Inactive</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="form-footer">
                          <button
                            type="submit"
                            id="add-sub"
                            className="btn btn-info"
                          >
                            {id ? "Update" : "Add"}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {message === "Firmware updated successfully!" && (
        <SuccessMessage message={message} />
      )}

      {message === "Failed to update firmware." && (
        <FailedMessage message={message} />
      )}
    </>
  );
};

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}

export default UpdateFirmware;